import CloudinaryImage from './cloudinary_image';

export default CloudinaryImage;
